import React from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';

import LoadingSpinner from '../../ui/LoadingSpinner';

import DarHistory from './DarHistory';

import app from '../../../app.module.css';
import dropdown from '../../../commonStyles/rowExpand.module.css';

const DarDetails = ({ row, onClose }) => {
    return !row ? (
        <LoadingSpinner content="No DAR history found" />
    ) : (
        <div className={`${dropdown.rowDropdown} ${dropdown.redBorder}`}>
            <div className={app.sectionHeading}>DAR History</div>
            {row.history.length ? (
                row.history.map((el) => (
                    <DarHistory key={`${el.date}_${el.status}_${el.userId}`} history={el} />
                ))
            ) : (
                <div className={dropdown.noEntries}>No history</div>
            )}
            <div className={dropdown.exit} onClick={onClose}>
                Close details
                <CloseIcon />
            </div>
        </div>
    );
};

DarDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default DarDetails;
